import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';


Swiper.use([Autoplay, Navigation, Pagination]);

let headerSwiper = null;

let produktSwiper = null;

let detailSwiper = null;


headerSwiper = new Swiper(".headerSwiper", {
    spaceBetween: 0,
    loop: true,
    centeredSlides: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".headerSwiper .swiper-button-next",
      prevEl: ".headerSwiper .swiper-button-prev",
    },
    slidesPerView: 1
});

produktSwiper = new Swiper(".produktSwiper", {
  spaceBetween: 30,
  loop: true,
  centeredSlides: false,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".product_list .swiper-button-next",
    prevEl: ".product_list .swiper-button-prev",
  },
  slidesPerView: 1, 
  breakpoints: {
    900: {
      slidesPerView: 4 
    },
    768: {
      slidesPerView: 2 
    }
  }
});



detailSwiper = new Swiper(".gallerySwiper", {
  spaceBetween: 20,
  loop: true,
  centeredSlides: false,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".detail-gallery .swiper-button-next",
    prevEl: ".detail-gallery .swiper-button-prev",
  },
  slidesPerView: 4
});


